import { Replicant, ReplicantConfig } from '../ReplicantConfig';

export function getAppName<T extends Replicant>(config: ReplicantConfig<T>) {
    try {
        return process.env.APP_NAME || config.appName;
    } catch (e) {
        return config.appName;
    }
}
